import { useState } from 'react';
import { IconName } from '@optimus-web/icons';
import { lt } from '@mews/framework';
import { Divider, DropdownItem } from '@optimus-web/core';
import { AssistantMessageRecordDto, AssistantMessageRole } from '@mews-commander/data-access';
import { Loader } from '@mews-commander/ui';
import { useAssistantMessageReplyQuery } from '../../query/useAssistantMessageReplyQuery';
import { MenuButton } from './MenuButton';
import { ErrorButton } from './ErrorButton';

interface SuggestionActionsMenuProps {
    messageHistory: AssistantMessageRecordDto[];
    selectedSummary: string | undefined;
    handleSelectedSuggestion: (suggestion: string) => void;
    handleAccept: () => void;
    handleDiscard: () => void;
}

export const SuggestionActionsMenu = ({
    messageHistory,
    selectedSummary,
    handleSelectedSuggestion,
    handleAccept,
    handleDiscard,
}: SuggestionActionsMenuProps) => {
    const [currentMessageHistory, setCurrentMessageHistory] = useState<AssistantMessageRecordDto[]>(messageHistory);
    const {
        data: suggestion,
        isLoading,
        refetch,
        isRefetching,
        error,
    } = useAssistantMessageReplyQuery(selectedSummary, currentMessageHistory);

    if (suggestion) {
        handleSelectedSuggestion(suggestion.message);
    }

    if (isLoading || isRefetching) {
        return <DropdownItem label={lt('CommunicationHubDraftingAIReply')} leftDetail={<Loader size="small" />} />;
    }

    if (error) {
        return <ErrorButton handleClick={async () => refetch()} />;
    }

    const handleRewrite = async () => {
        setCurrentMessageHistory([
            ...currentMessageHistory,
            { content: suggestion?.message, role: AssistantMessageRole.Assistant },
        ]);
        await refetch();
    };

    return (
        <>
            <MenuButton icon={IconName.Done} onClick={handleAccept} label={lt('Accept')} />
            <MenuButton icon={IconName.Refresh} onClick={handleRewrite} label={lt('Rewrite')} />
            <Divider />
            <MenuButton icon={IconName.Delete} onClick={handleDiscard} label={lt('Discard')} destructive />
        </>
    );
};
